/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useState,useEffect} from "react";

import firebase from '../config/firebase'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

function User() {
  
const [data,setdata]=useState([]);
useEffect(()=>{

  firebase.firestore().collection('booking').
  where('hotel_admin_uid', '==', localStorage.getItem('admin_uid'))
  .onSnapshot((querySnapshot) => {
    var all = [];
    querySnapshot.forEach((doc) => {
      all.push(doc.data());
        // console.log("Current cities in CA: ", doc.data());
    });
    
    console.log("cart in cart comp",all);
   setdata(all)
    });
},[])
  return (
    <>
      <div id="centerME" style={{marginTop:100,width:'98%',marginLeft:'1%'}}>
              <div className="boxStAc1">
             
             
                <table id='tableAll' className="table-hover">
                  <thead>
                    <tr style={{backgroundColor:'#343A40',height:50}}>
                      <th scope="col" style={{color:'#fff'}}>Sr No.</th>
                      <th scope="col"colSpan={2} style={{color:'#fff'}} >Name
                      </th>
                      <th scope="col" style={{color:'#fff'}} >Room No
                      </th>
                      <th scope="col"style={{color:'#fff'}} >check_in
                        </th>
                      <th scope="col" style={{color:'#fff'}}>check_out</th>
                      <th scope="col" style={{color:'#fff'}}>Price</th>
                      
                      
        
                    </tr>
                  </thead>
  
                  <tbody >
    {data.map((v,i)=>{
      return(

        <tr>
        <td data-label="Sr No.">{i}</td>
        <td data-label="Room Accomodation"colSpan={2} >{v.user_name}</td>
        <td data-label="Room No">{v.room}</td>
        <td data-label="Status">{v.check_in} </td>
        <td data-label="Price">{v.check_out}</td>
        <td data-label="Price">{v.price}</td>
      
       
      </tr>
    //     <tr>
    //   <th scope="row">{i}</th>
    //   <td>{v.user_name}</td>
    //   <td>{v.room}</td>
    //   <td>{v.check_in}</td>
    //   <td>{v.check_out}</td>
    //   <td>$ {v.price}</td>
    // </tr>
    
      )
    })}
      </tbody>
  </table>
              </div>
            </div>
    </>
  );
}

export default User;
